import React from 'react';
import hamburger from '../../assets/images/hamburger.png';
import classes from './Menu.css';

const Menu = (props) => (
        <div className={classes.Menu}>
            <img src={hamburger} alt="Menu" height="50px" width="50px" onClick={props.click}/>
        </div>
);

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js